import React from "react";
import { useNavigate } from "react-router-dom";

type SuccessModalProps = {
  isVisible: boolean;
  onClose: () => void;
};

const OnboardSuccessModal: React.FC<SuccessModalProps> = ({
  isVisible,
  onClose,
}) => {
  const navigate = useNavigate();

  if (!isVisible) return null;

  const handleOk = () => {
    onClose();
    navigate("/");
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-[100] bg-black bg-opacity-50">
      <div className="bg-white rounded-lg p-8 shadow-lg text-center max-w-md w-full mx-4">
        <h2 className="text-2xl font-bold text-green-600 mb-4">
          Onboarding Completed!
        </h2>
        <p className="text-gray-600 mb-6">
          Your onboarding form has been submitted successfully. We will review
          your details and get back to you shortly.
        </p>
        <button
          className="px-8 py-2 bg-red font-bold text-white rounded-md w-full"
          onClick={handleOk}
        >
          OK
        </button>
      </div>
    </div>
  );
};

export default OnboardSuccessModal;
